import { clsx } from 'clsx';

import { useFormat } from '@/hooks/useFormat';
import type { FormatType } from '@/utils/format';
import { makeAmountGrey, tnum } from '@/utils/styles';

type AmountProps = {
  value: number | null | undefined;
  type?: FormatType;
  className?: string;
  /** Grey out exact zeros, the way the budget grid does. */
  greyZero?: boolean;
  title?: string;
};

/** A right-aligned, tabular, privacy-aware money cell. */
export function Amount({
  value,
  type = 'financial',
  className,
  greyZero = false,
  title,
}: AmountProps) {
  const format = useFormat();
  return (
    <span
      title={title}
      data-testid="amount"
      className={clsx('tnum inline-block text-right', className)}
      style={{
        ...tnum,
        ...(greyZero ? makeAmountGrey(value ?? 0) : undefined),
      }}
    >
      {format(value, type)}
    </span>
  );
}
